import React, { useState, useEffect } from 'react';
// import Nav from '../pages/HomePage/Nav';
import {Link, Navigate} from 'react-router-dom';
import {connect} from 'react-redux';
import {reset_password} from '../actions/authAction'
import './ResetPassword.css';
import Nav from '../containers/Home/Nav';
const ResetPassword = ({reset_password}) => {
    const [requestSent, setRequestSent] = useState(false)
    const [formData, setFormData] = useState({ email: '' });
    const [redirect, setRedirect] = useState(false)


    const { email } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        e.preventDefault();
        reset_password(email);
        setRequestSent(true);
    };
    // if (requestSent) {
    //     return <Navigate to='/' />
    // }
    useEffect(() => {
        if (requestSent) {
            const timer = setTimeout(() => setRedirect(true), 15000);
            return () => clearTimeout(timer);
        }
    }, [requestSent]);

    if (redirect) {
        return <Navigate to='/login' />
    }

    return (
        <>
            <Nav/>
            <div className='sign-warapper'>
                <div className='container-reset'>
                    <p className='form-title'>تغيير كلمة المرور</p>
                    <form onSubmit={onSubmit}>
                        <p className='reset-text'>
                        اكتب بريدًك الالكتروني واضغط على ارسال. سيصلك ايميل مع رابط تغيير كلمة المرور.
                        </p>
                        <div className='input-container'>
                            <p className='input-label'>البريد الالكتروني</p>
                            <input
                                className='input'
                                type='email'
                                name='email'
                                value={email}
                                placeholder='البريد الالكتروني'
                                onChange={onChange}
                                required
                            />
                        </div>
                        <button className='btn' type='submit'> ارسال</button>
                    </form>
                </div>
            </div>
            {requestSent && (
                <div className='reset-popup-overlay'>
                    <div className='reset-popup'>
                        <p>تم إرسال رابط لتعيين كلمة مرور جديدة إلى بريدك الإلكتروني.</p>
                        <p>سيتم تحويلك لصفحة تسجيل الدخول بعد قليل.</p>
                    </div>
                </div>
            )}
        </>
    );
}


export default connect(null, {reset_password})(ResetPassword);
